/**
 * Initialize the 'mfa' state.
 *
 * NOTE: this state is intentionally NOT persisted, the `mfaToken`, the shared
 * `secret` and the `qrCode` of an enrollment are short lived and must not be
 * written to `localStorage`.
 *
 * @type {Object}
 */
const INITIAL_STATE = {
    // The methods the user is allowed to enroll into (`MFA_REQUIRED` responses).
    allowedMethods: [],
    // The error returned by the last enrollment attempt.
    enrollmentError: null,
    // The `status` returned by the register API for the started enrollment.
    enrollmentStatus: '',
    // The error returned by the last verification attempt.
    error: null,
    // Is an enrollment request in flight?
    isRegistering: false,
    // Is the sign in of a completed enrollment in flight?
    isCompletingEnrollment: false,
    // Has the enrollment just been completed, i.e. is the success screen due?
    isEnrollmentComplete: false,
    // Is a verification request in flight?
    isVerifying: false,
    // The login credentials needed to complete the post sign in redirect.
    loginContext: {},
    // The MFA method the user has enrolled (`MFA_ENROLLED` responses).
    method: '',
    // The short lived token used to authorize the MFA APIs.
    mfaToken: '',
    // The OAuth token set of a completed enrollment, held in memory until the
    // user leaves the success screen and the sign in is completed.
    pendingToken: null,
    // The `otpauth://` URI of the started enrollment, held in memory only.
    qrCode: '',
    // The attempts left in the current challenge, as reported by the API.
    remainingAttempts: null,
    // The shared secret of the started enrollment, held in memory only.
    secret: '',
    // The `status` returned by the authenticate API.
    status: '',
};

export default INITIAL_STATE;
